import { CommonModule } from "@angular/common";
import { Component, signal } from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatTabsModule } from '@angular/material/tabs';
import { MailkitComponent } from "../mailKit/mailkit.component";
import { QuoteParametersComponent } from "../quoteParameters/quote-parameters.component";
import { FileconfigComponent } from "../fileconfig/fileconfig.component";
import { SystemConfigComponent } from "../system-config/system-config.component";

@Component({
    selector: 'app-system-settings',
    standalone: true,
    imports: [CommonModule, MatExpansionModule, MatTabsModule, MailkitComponent, QuoteParametersComponent,FileconfigComponent,SystemConfigComponent],
    templateUrl: './system-settings.component.html',
    styleUrl: './system-settings.component.scss'
})
export class SystemSettingsComponent{
    selectedTab = signal(0);

    onTabChange(index: number): void {
        this.selectedTab.set(index);
    }
}